import React from "react";
export const FooterInmersys = () => {
    const date = new Date();

    return (
        <div className="flex justify-center items-center">
            <p>Inmersys {date.getFullYear()}</p>
        </div>
    );
};
